import React from 'react';
import { Route, Routes } from 'react-router-dom';
import App from './App';
import Home from './components/Home';
import withNavigation from './services/withNavigation';
import Layout from "./components/Layout";
import Book from "./components/books/Book";
import SearchBook from "./components/Search/SearchBook";
import ROUTES from "./route";
import GoogleBook from "./components/books/GoogleBook";
import { BooksProvider } from "./components/State/bookContext";
import UserProfile from "./components/User/Profile";
import Library from "./components/books/Library/Library";
import CreateBook from "./components/books/CreateBook/CreateBook";
import EditBook from "./components/books/CreateBook/EditBook";
import Author from "./components/Authors/Author";
import AdminIndex from "./components/Admin/AdminIndex";
import AdminGenres from "./components/Admin/AdminGenres";
import AdminAuthors from "./components/Admin/AdminAuthors";
import AdminBooks from "./components/Admin/AdminBooks";
import AdminUsers from "./components/Admin/AdminUsers";
import Logout from "./components/User/Logout";
import { UserProvider } from "./components/State/UserContext";
import ProtectedRoute from "./components/User/ProtectedRoute";
import Landing from "./components/Landing";
import Register from "./components/User/Register";

const AppWithNavigation = withNavigation(App);

const AppRoutes = () => {
    return (
        <UserProvider>
            <BooksProvider>
                <Routes>
                    <Route path={ROUTES.DEFAULT}  element={<Landing />} />
                    <Route path={ROUTES.LOGIN}    element={<AppWithNavigation />} />
                    <Route path={ROUTES.REGISTER} element={<Register />} />
                    <Route path={ROUTES.HOME}     element={
                        <ProtectedRoute>
                            <Layout><Home /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.BOOK_SHOW}    element={
                        <ProtectedRoute>
                            <Layout><Book /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.SEARCH_BOOK}  element={
                        <ProtectedRoute>
                            <Layout><SearchBook /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.GOOGLE_BOOK}  element={
                        <ProtectedRoute>
                            <Layout><GoogleBook /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.USER_PROFILE} element={
                        <ProtectedRoute>
                            <Layout><UserProfile /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.LIBRARY}      element={
                        <ProtectedRoute>
                            <Layout><Library /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.CREATE_BOOK}  element={
                        <ProtectedRoute>
                            <Layout><CreateBook /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.EDIT_BOOK}    element={
                        <ProtectedRoute>
                            <Layout><EditBook /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.AUTHOR_SHOW}  element={
                        <ProtectedRoute>
                            <Layout><Author /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.LOGOUT}       element={
                        <ProtectedRoute>
                            <Layout><Logout /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.ADMIN} element={
                        <ProtectedRoute requiredRole="admin">
                            <Layout><AdminIndex /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.ADMIN_GENRES}  element={
                        <ProtectedRoute requiredRole="admin">
                            <Layout><AdminGenres /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.ADMIN_AUTHORS} element={
                        <ProtectedRoute requiredRole="admin">
                            <Layout><AdminAuthors /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.ADMIN_BOOKS}   element={
                        <ProtectedRoute requiredRole="admin">
                            <Layout><AdminBooks /></Layout>
                        </ProtectedRoute>
                    } />
                    <Route path={ROUTES.ADMIN_USERS}   element={
                        <ProtectedRoute requiredRole="admin">
                            <Layout><AdminUsers /></Layout>
                        </ProtectedRoute>
                    } />
                </Routes>
            </BooksProvider>
        </UserProvider>
    );
};

export default AppRoutes;
